import Resource from './resource-class'

class ExtractionSolventAPI extends Resource {
  constructor () {
    super()
    this.resource = '/extract_extraction_solvent'
  }
}

export default new ExtractionSolventAPI()
